<template>
    <div class="container" style="padding: 12px;">
        <div>
            <el-button type="primary" @click="export4ImagesFromStock()">导出所有在库钱币前四张图片</el-button>
            <div>完成：{{finish}}/{{total}}</div>
        </div>
    </div>
</template>
<script>

import { API, doGet } from "@/api/api.js"
import axios from 'axios'

export default {
    data: function () {
        return {
            finish: 0,
            total: 0,
        }
    },
    methods: {
        export4ImagesFromStock: async function() {
            let products = (await doGet(API.SETTING.EXPORT4IMAGES));
            let urls = [];
            for (let i = 0; i < products.length; i++) {
                if (!products[i].productImages) {
                    continue;
                }
                if (products[i].productImages.split(',').length < 4) {
                    continue;
                }
                if (i < 755) {
                    continue;
                }
                let imgs = products[i].productImages.split(',');
                this.total = imgs.length;
                if (imgs) {
                    for (let j = 0; j < (imgs.length > 4 ? 4 : imgs.length); j++) {
                        urls.push({
                            name: (i + 1) + "-" + (j + 1) + ".jpg",
                            url: process.env.VUE_APP_FILE + imgs[j]
                        });
                    }
                }
            }
            console.log(urls)
            for (let i = 0; i < urls.length; i++) {
                this.downloadSingleImage(urls[i].url, urls[i].name);
            }
        },
        downloadSingleImage: function (url, name) {
            axios({
                url,
                method: "GET",
                responseType: 'blob'
            }).then(res => {
                const blob = new Blob([res.data]);
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = name;
                a.click();
                URL.revokeObjectURL(url);
                this.finish++;
            });
        },
    },
    created: async function () {

    }
}
</script>
<style scoped lang="less">
</style>